'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppFrame = require('./AppFrame');

var _AppFrame2 = _interopRequireDefault(_AppFrame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AppFrame2.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-components/lib/AppFrame/index.js
// module id = 338
// module chunks = 0